import React from 'react';
import core, { App, Poller } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router-dom';

import matchList from 'modules/match-list';
import { MatchListType } from 'app-constants';

const {
    poller: { withPolling },
} = core;
const {
    actions: { searchMatches },
    selectors: { selectFetchStatus },
    pagination: {
        selectors: { selectIsPollingTurnedOff },
    },
    components: { MatchListContainer },
} = matchList;

interface OwnProps extends RouteComponentProps<any> {}

interface MappedProps {
    isPollingTurnedOff: boolean;
    fetchStatus: App.FetchStatus;
}

type Props = OwnProps &
    MappedProps & {
        poller: Poller.Poller<typeof searchMatches>;
    };

class Results extends React.Component<Props> {
    render() {
        const { fetchStatus, poller } = this.props;

        return (
            <MatchListContainer
                type={MatchListType.RESULTS}
                fetchStatus={fetchStatus}
                poller={poller}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    isPollingTurnedOff: selectIsPollingTurnedOff,
    fetchStatus: selectFetchStatus,
});

export default compose(
    connect<MappedProps, {}, OwnProps>(mapStateToProps),
    withPolling({
        pollerName: App.PollerName.Results,
        executableAction: searchMatches,
    })
)(Results);
